<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ label(params.value) }}</span>
  </vs-chip>
</template>
<script>
import { VesselMixin } from "@/mixins";
export default {
  name: "CellRendererVesselCategory",
  mixins: [VesselMixin],
  computed: {
    chipColor() {
      return value => {
        return this.vesselCategory.properties[value].color;
      };
    },
    label() {
      return value => {
        return this.vesselCategory.properties[value].name_ja;
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
